import { ReactNode, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './HeaderBui.module.css';

export type HeaderBuiProps = {
  className?: string;
  children?: ReactNode;
  dense?: boolean;
};

export const HeaderBui = forwardRef<HTMLDivElement, HeaderBuiProps>(
  (props, ref) => {
    const { className, children, dense } = props;
    return (
      <div
        ref={ref}
        className={classNames(styles.root, className, {
          [styles.dense]: dense,
        })}
      >
        {children}
      </div>
    );
  },
);

HeaderBui.displayName = 'DialogCompositeBui.Header';

export default HeaderBui;
